import { createFileRoute } from '@tanstack/react-router';

import { PortalOverviewPage } from '@/modules/portal/pages/PortalOverviewPage';

export const Route = createFileRoute('/account/')({
  component: PortalOverviewPage,
});
